import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Sticky } from 'react-sticky';

import { throttle } from 'core/libs/lodash';

import {
  MOBILE_BIG,
  DESKTOP_BIG,
  viewportBreakpoints,
} from 'core/components/breakpoint/viewport-values';

import themePropTypes from 'core/utils/prop-types/theme';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

import styles from './index.styl';


/**
 * @author Artyom Gavrilyuk <a.gavrilyuk@rambler-co.ru>
 */
class StickyShapka extends Component {
  static propTypes = {
    /**
     * Sticky-шапка в ширину на полный экран.
     */
    fullwidth: PropTypes.bool,

    /** @ignore */
    isMobile: PropTypes.bool,

    /** @ignore */
    theme: themePropTypes(`
      {
        controls: {
          shapka: {
            padding,
            shadow,
            background,
            backgroundOpened,
            height,
            dropdown: {
              fullwidth,
            },
          },
        },
      }
    `),

    /**
     * Первая шапка для премиум топика. Отображается на фоне обложки.
     */
    isFirstShapkaForPremium: PropTypes.bool,

    /**
     * Вторая шапка для премиум топика. Отображается после скролла обложки.
     */
    isSecondShapkaForPremium: PropTypes.bool,

    /**
     * Значение z-index
     */
    zIndex: PropTypes.number,

    /**
     * Уменьшать ли шапку при скролле
     */
    isSmallerHeader: PropTypes.bool,

    /**
     * Шапка находится в верхней позиции
     */
    topPosition: PropTypes.bool,

    /**
     * Контроль стейта родителя
     */
    upperStateHandler: PropTypes.func,
  };

  componentDidMount() {
    if (window.scrollY > 0) {
      this.detectScrollDirection();
    }
    window.addEventListener('scroll', this.detectScrollDirection);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.detectScrollDirection);
  }

  headerRef = React.createRef();

  detectScrollDirection = throttle(() => {
    const {
      isSmallerHeader,
      topPosition,
      upperStateHandler,
      isMobile,
    } = this.props;

    const { scrollY } = window;
    const headerOffset = this.headerRef.current ? this.headerRef.current.getBoundingClientRect().top : 0;
    const headerPos = headerOffset + scrollY;

    if (scrollY <= headerPos && !topPosition) {
      upperStateHandler({
        topPosition: true,
      });
    } else if (scrollY > headerPos && topPosition) {
      upperStateHandler({
        topPosition: false,
      });
    }

    if (!isMobile && scrollY > this.props.theme.controls.shapka.height) {
      if (!isSmallerHeader) {
        upperStateHandler({
          isSmallerHeader: true,
        });
      }
    } else if (isSmallerHeader) {
      upperStateHandler({
        isSmallerHeader: false,
      });
    }
  }, 100);


  render() {
    const {
      children,
      theme: {
        controls: {
          shapka: shapkaStyles,
        },
      },
      isMobile,
      fullwidth,
      isFirstShapkaForPremium,
      isSecondShapkaForPremium,
      zIndex,
      topPosition,
    } = this.props;

    const {
      shadow,
      shadowTransition,
      height: shapkaHeight,
      topIndent,
    } = shapkaStyles;

    const scope = resolveScopedStyles(
      <scope>
        <style jsx>{`
          .${styles.stickyHeader}
            z-index ${zIndex}
            &:after
              box-shadow ${isFirstShapkaForPremium ? 'none' : shadow}
              transition ${shadowTransition}
            &.${styles._toHide}
              z-index -1
        `}</style>
      </scope>
    );

    return (
      <Sticky disableCompensation>
        {({ style, isSticky }) => {
          return (
            <div>
              <div
                ref={this.headerRef}
                style={{
                  // для премиум топика высота 0px, чтобы контент не скакал
                  height: isSecondShapkaForPremium ? 0 : shapkaHeight,
                }}
              />
              <div
                className={scope.wrapClassNames(
                  isMobile && 'mdsp-sticky-billboard',
                  styles.stickyHeader,
                  isSticky && styles._isSticked,
                  !topPosition && styles._withShadow,
                  isSecondShapkaForPremium &&
                    (topPosition ? styles._toHide : styles._toShow),
                )}
                style={{
                  ...style,
                  // В FF некорректно определяется position из style, задаём исходя из topPosition
                  ...topPosition && {
                    position: 'absolute',
                    left: '0px',
                    ...topIndent && {
                      transform: `translateY(${topIndent})`,
                    },
                  },
                  ...fullwidth ? {
                    left: '0px',
                    width: '100%',
                  } : {
                    maxWidth: viewportBreakpoints[isMobile ? MOBILE_BIG : DESKTOP_BIG],
                  },
                }}
              >
                {children}
              </div>
              <scope.styles />
            </div>
          );
        }}
      </Sticky>
    );
  }
}

export default StickyShapka;
